<template>
  <div class="orders">
    <!-- 筛选栏 -->
    <el-card shadow="never" class="filter-card">
      <div class="filter-row">
        <div class="status-btns">
          <el-button
            v-for="item in statusTabs"
            :key="item.value"
            :type="currentStatus === item.value ? 'danger' : 'default'"
            size="small"
            round
            @click="switchStatus(item.value)"
          >
            {{ item.label }}
            <span v-if="item.count !== undefined" class="count-badge">({{ item.count }})</span>
          </el-button>
        </div>
        <div class="search-box">
          <el-input v-model="searchKey" placeholder="订单号/手机号" size="small" style="width:200px" clearable @keyup.enter.native="searchOrders" />
          <el-button type="primary" size="small" @click="searchOrders">搜索</el-button>
        </div>
      </div>
    </el-card>

    <!-- 订单表格 -->
    <el-card shadow="never" style="margin-top:16px">
      <el-table :data="orderList" border stripe v-loading="loading">
        <el-table-column prop="order_no" label="订单号" width="160">
          <template slot-scope="scope">
            <span class="order-no">{{ scope.row.order_no }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商品信息" min-width="200">
          <template slot-scope="scope">
            <div class="goods-info">
              <el-image :src="scope.row.goods_img" style="width:48px;height:48px;border-radius:4px" fit="cover" />
              <span class="goods-name">{{ scope.row.goods_name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="用户昵称" width="100">
          <template slot-scope="scope">{{ scope.row.user_name || '未知用户' }}</template>
        </el-table-column>
        <el-table-column label="订单金额" width="120">
          <template slot-scope="scope">
            <span class="amount-text">&yen; {{ scope.row.total_amount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="下单时间" width="150" />
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="orderStatusTag(scope.row.status)" size="small">{{ orderStatusText(scope.row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === 1" type="text" size="mini" @click="openShipDialog(scope.row)">去发货</el-button>
            <el-button v-if="scope.row.status === 4" type="text" size="mini" style="color:#e6a23c" @click="openRefundDialog(scope.row)">处理</el-button>
            <el-button type="text" size="mini" @click="viewDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination background layout="total, prev, pager, next" :total="total" :page-size="10" :current-page="page" @current-change="onPageChange" />
      </div>
    </el-card>

    <!-- 发货弹窗 -->
    <el-dialog title="订单发货" :visible.sync="shipDialogVisible" width="500px">
      <p style="margin-bottom:16px">正在为订单 <strong>{{ shipOrder.order_no }}</strong> 发货</p>
      <el-form label-width="100px">
        <el-form-item label="快递公司">
          <el-select v-model="shipForm.dhl" placeholder="请选择快递公司" style="width:100%">
            <el-option v-for="d in dhlList" :key="d" :label="d" :value="d" />
          </el-select>
        </el-form-item>
        <el-form-item label="快递单号">
          <el-input v-model="shipForm.dhl_no" placeholder="请输入快递单号" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="shipDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitShip">确认发货</el-button>
      </div>
    </el-dialog>

    <!-- 售后处理弹窗 -->
    <el-dialog title="售后处理" :visible.sync="refundDialogVisible" width="400px">
      <p>确认处理该售后订单 <strong>{{ refundOrder.order_no }}</strong>？</p>
      <el-radio-group v-model="refundAction" style="margin:16px 0">
        <el-radio label="approve">同意退款</el-radio>
        <el-radio label="reject">拒绝退款</el-radio>
      </el-radio-group>
      <el-input v-model="refundRemark" type="textarea" :rows="2" placeholder="处理备注（选填）" />
      <div slot="footer">
        <el-button @click="refundDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitRefund">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getOrders, shipmentOrder, refundOrder } from '@/api'

export default {
  name: 'Orders',
  data() {
    return {
      currentStatus: 'all',
      statusTabs: [
        { label: '全部', value: 'all' },
        { label: '待付款', value: 0, count: 0 },
        { label: '待发货', value: 1 },
        { label: '已完成', value: 3 },
        { label: '售后', value: 4, count: 0 }
      ],
      searchKey: '',
      orderList: [],
      loading: false,
      total: 0,
      page: 1,
      shipDialogVisible: false,
      shipOrder: {},
      shipForm: { dhl: '顺丰速运', dhl_no: '' },
      dhlList: ['顺丰速运', '京东快递', '中通快递', '圆通速递', '韵达快递', '申通快递'],
      refundDialogVisible: false,
      refundOrder: {},
      refundAction: 'approve',
      refundRemark: ''
    }
  },
  mounted() {
    this.loadOrders()
  },
  methods: {
    async loadOrders() {
      this.loading = true
      try {
        const params = { page: this.page, limit: 10, title: this.searchKey }
        if (this.currentStatus !== 'all') params.status = this.currentStatus
        const res = await getOrders(params)
        this.orderList = res.data || res || []
        this.total = res.total || 0
        if (res.counts) {
          const c = res.counts
          this.statusTabs[1].count = c.pending_pay || 0   // 待付款
          this.statusTabs[2].count = c.pending_ship || 0   // 待发货
          this.statusTabs[4].count = c.after_sale || 0     // 售后
        }
      } catch (e) {}
      this.loading = false
    },
    switchStatus(val) {
      this.currentStatus = val
      this.page = 1
      this.loadOrders()
    },
    searchOrders() {
      this.page = 1
      this.loadOrders()
    },
    onPageChange(page) {
      this.page = page
      this.loadOrders()
    },
    orderStatusTag(status) {
      const map = { 0: 'warning', 1: '', 2: 'info', 3: 'success', 4: 'danger', 5: 'warning' }
      return map[status] || 'info'
    },
    orderStatusText(status) {
      const map = { 0: '待付款', 1: '待发货', 2: '待收货', 3: '已完成', 4: '已退款', 5: '售后申请中' }
      return map[status] || '未知'
    },
    openShipDialog(row) {
      this.shipOrder = row
      this.shipForm = { dhl: '顺丰速运', dhl_no: '' }
      this.shipDialogVisible = true
    },
    async submitShip() {
      if (!this.shipForm.dhl_no) { this.$message.warning('请输入快递单号'); return }
      try {
        await shipmentOrder({ order_id: this.shipOrder.id, ...this.shipForm })
        this.$message.success('发货成功')
        this.shipDialogVisible = false
        this.loadOrders()
      } catch (e) {
        this.$message.error(e.message || '发货失败')
      }
    },
    openRefundDialog(row) {
      this.refundOrder = row
      this.refundAction = 'approve'
      this.refundRemark = ''
      this.refundDialogVisible = true
    },
    async submitRefund() {
      try {
        await refundOrder({ order_id: this.refundOrder.id, action: this.refundAction, remark: this.refundRemark })
        this.$message.success('处理成功')
        this.refundDialogVisible = false
        this.loadOrders()
      } catch (e) {
        this.$message.error(e.message || '处理失败')
      }
    },
    viewDetail(row) {
      this.$router.push('/orders/' + row.id)
    }
  }
}
</script>

<style scoped>
.filter-card { margin-bottom: 0; }
.filter-row { display: flex; justify-content: space-between; align-items: center; }
.status-btns { display: flex; gap: 8px; }
.count-badge { color: #3a8ee6; }
.search-box { display: flex; gap: 8px; }
.goods-info { display: flex; align-items: center; gap: 10px; }
.goods-name { font-size: 13px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 180px; }
.order-no { font-size: 12px; font-family: monospace; }
.amount-text { color: #3a8ee6; font-weight: bold; }
.pagination-box { text-align: right; margin-top: 16px; }
</style>
